/**
 * Undo/redo from the keyboard anywhere on the screen.
 *
 * It used to be one half of a pair: Terra Draw shipped its own matcher bound to the map
 * canvas, so this one declined canvas events to keep a single Ctrl+Z from undoing twice.
 * Geoman has no undo of its own and Leaflet has no canvas — the drawing is SVG in a pane —
 * so there is no second listener to coordinate with, and the canvas refusal is gone. Kept,
 * it would switch the shortcut off over the very surface it exists to serve.
 *
 * One refusal is left, and it is the one that matters: inside a text field Ctrl+Z means the
 * text, not the polygon.
 */

import { isTypingTarget } from "../lib/dom";

export type DrawShortcut = "undo" | "redo" | null;

interface ShortcutEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  target: EventTarget | null;
}

export const drawShortcut = (event: ShortcutEvent): DrawShortcut => {
  if (!event.ctrlKey && !event.metaKey) return null;
  if (isTypingTarget(event.target)) return null;
  const key = event.key.toLowerCase();
  if (key === "y" && !event.shiftKey) return "redo";
  if (key !== "z") return null;
  return event.shiftKey ? "redo" : "undo";
};
